import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-links">
        <Link to="/about" className="footer-link">About Us</Link>
        <Link to="/contact" className="footer-link">Contact Us</Link>
        <Link to="/support" className="footer-link">Support</Link>
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        <Link to="/terms" className="footer-link">Terms &amp; Conditions</Link>
        <Link to="/delete-account" className="footer-link">Delete Account</Link>
      </div>
      <div className="footer-copy">
        <span className="copy-icon">©</span> 2026 MYHELPZ
      </div>
    </footer>
  );
};

export default Footer;

